import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent {
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(): void {   
    this.titleService.setTitle('About Us');
  }

}
